import { MatrixDescriptor } from './types';
import { MATEMATICA_DESCRIPTORS } from './matematica';
import { CIENCIAS_NATUREZA_DESCRIPTORS } from './cienciasNatureza';
import { HUMANAS_LINGUAGENS_DESCRIPTORS } from './humanasLinguagens';

export * from './types';
export * from './matematica';
export * from './cienciasNatureza';
export * from './humanasLinguagens';

export const ANEXO_VI_DESCRIPTORS: MatrixDescriptor[] = [
  ...MATEMATICA_DESCRIPTORS,
  ...CIENCIAS_NATUREZA_DESCRIPTORS,
  ...HUMANAS_LINGUAGENS_DESCRIPTORS,
];

export const DESCRIPTOR_BY_ID: Record<string, MatrixDescriptor> = Object.fromEntries(
  ANEXO_VI_DESCRIPTORS.map((d) => [d.id, d])
);
